// extracted by mini-css-extract-plugin
export var backdrop = "ShellDock-module--backdrop--22346";
export var card = "ShellDock-module--card--7777c";